export default __webpack_public_path__ + "static/media/Resume(Vinayak-Sharma).3d81c68a.pdf";